import RemoteErrorsInterceptor, { withErrors } from "ra-remote-validator";
import React from "react";
import { required, SimpleForm, TextInput } from "react-admin";
import { compose } from "recompose";
import Create from "../components/form/Create";

const RoleCreate = ({ dispatch, validate, errors, ...props }) => (
	<Create {...props}>
		<SimpleForm variant="outlined" redirect="list" validate={validate}>
			<RemoteErrorsInterceptor errors={errors} dispatch={dispatch} />
			<TextInput validate={required()} source="code" fullWidth />
			<TextInput validate={required()} source="name" fullWidth />
		</SimpleForm>
	</Create>
);

export default compose(withErrors)(RoleCreate);
